import styled from "styled-components"
import Icon from "../Icon/Icon"
import {faChevronRight, faHouseBlank} from "@fortawesome/pro-regular-svg-icons"
import {useNavigate} from "react-router-dom"

const Navigation = ({items, ...props}) => {
	const navigate = useNavigate()

	return (
		<Wrapper {...props}>
			<a onClick={() => navigate('/')}><Icon name={faHouseBlank} size={20}/></a>
			{items.map(item => (
				<>
					<Icon name={faChevronRight} style={{opacity: .6}}/>
					<a onClick={() => navigate(item.url)}>{item.title}</a>
				</>
			))}
		</Wrapper>
	)
}

export default Navigation

const Wrapper = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    align-items: center;
    line-height: 20px;

    a {
        opacity: .6;
        text-decoration: none;

        :hover {
            opacity: 1;
        }
    }
`